import React from "react";
import { Form } from "react-bootstrap";

const RadioButtonLayout = props => {
  const {
    label,
    className,
    formData,
    isRequiredField,
    onChange,
    toggleLableName,
    name,
    radioButtonMarginWithoutLabel,
    isFromAgendaDeatil
  } = props;
  return (
    <Form.Group className={`${className}`}>
      <Form.Label className={`${isFromAgendaDeatil ? "mb-2" : ""}`}>
        {label} {isRequiredField ? <span className="required">*</span> : <></>}
      </Form.Label>
      <div
        className={`${
          radioButtonMarginWithoutLabel ? "radioButtonMarginWithoutLabel" : ""
        }`}
      >
        <div className="d-flex">
          <input
            type="radio"
            value={formData}
            name={name}
            checked={formData === name}
            onClick={event => onChange(event)}
          />
          <div className="toggleLabel ml-2">{toggleLableName}</div>
        </div>
      </div>
    </Form.Group>
  );
};
export default RadioButtonLayout;
